import { resetPasswordPath } from '@app/constants/url';

/**
 * Whether a `?token` in the URL is an OAuth refresh token this app should spend.
 *
 * Two different one-time tokens arrive under the same query parameter: the OAuth deep-link's refresh
 * token, and the password-reset token from the email. Spending the wrong one 401s in a loop and
 * overwrites the stored refresh token, so the route has to decide which is which.
 */
export const isAuthRefreshToken = (pathname: string, token: string | null | undefined): token is string =>
  !!token && pathname !== resetPasswordPath;

/** The query without the spent token. The rest is the mail's instruction to the page: see `?approve=1`. */
export const searchWithoutToken = (search: string): string => {
  const params = new URLSearchParams(search);
  params.delete('token');
  const rest = params.toString();

  return rest ? `?${rest}` : '';
};
